import loadImage from "blueimp-load-image";
import { canvasToBase64 } from "../helpers/utils";

const ImageLoader = ({
  handleChange,
  name,
  render,
  validTypes,
  handleInvalidType,
}) => {
  const isValidType = (file) => {
    const fileExtension = file.name.match(/\.[\w]+$/)[0];

    return validTypes.split(",").some((type) => {
      return fileExtension === type;
    });
  };

  const handleImageSelect = (e) => {
    const file = e.target.files && e.target.files[0];

    if (!file) {
      return;
    }

    if (!isValidType(file)) {
      handleInvalidType();
      return;
    }

    loadImage(
      file,
      canvasToBase64((base64Str) => handleChange(name, base64Str)),
      {
        maxWidth: 800,
        maxHeight: 800,
        contain: true,
        canvas: true,
        orientation: true,
        meta: true,
      }
    );
  };

  return render({ handleImageSelect, name });
};

export default ImageLoader;
